import { render, staticRenderFns } from "./hocSlider.vue?vue&type=template&id=4ee7e9a8&"
import script from "./hocSlider.vue?vue&type=script&lang=js&"
export * from "./hocSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports